import { GetterTree } from 'vuex';
import { RootState } from '@/store/index';
import { ApplicationUserState } from '@/store/modules/application-user/index';
import {
  APPLICATION_USER_INFO_ERRORS,
  APPLICATION_USER_LOADING,
  APPLICATION_USER_SEARCH_OBJECT,
  CHANGE_APP_USER_DETAILS_MODAL_ERRORS,
  CURRENT_APP_USER_DETAILS,
  OPEN_CHANGE_APP_USER_DETAILS_MODAL,
  USER_ADDITIONAL_INFO_LIST,
  USER_INFO_LIST,
} from '@/types/application-users.types';
import { Grid } from '@/models/Grid.model';
import { ApplicationUserInfoModel } from '@/models/backoffice/ApplicationUserInfoModel';
import { ApplicationUserAdditionalInfoModel } from '@/models/backoffice/ApplicationUserAdditionalInfoModel';
import { ApplicationUserSearchModel } from '@/models/backoffice/ApplicationUserSearchModel';
import { UserDetails } from '@/models/UserDetails.model';

export const getters: GetterTree<ApplicationUserState, RootState> = {

  [APPLICATION_USER_INFO_ERRORS](state): string[] {
    return state.applicationUserInfoErrors;
  },

  [APPLICATION_USER_LOADING](state): boolean {
    return state.applicationUserLoading;
  },

  [USER_INFO_LIST](state): Grid<ApplicationUserInfoModel> {
    return state.userInfoList;
  },

  [USER_ADDITIONAL_INFO_LIST](state): Grid<ApplicationUserAdditionalInfoModel> {
    return state.userAdditionalInfoList;
  },

  [CURRENT_APP_USER_DETAILS](state): UserDetails {
    return state.currentAppUserDetails;
  },

  [OPEN_CHANGE_APP_USER_DETAILS_MODAL](state): boolean {
    return state.openChangeAppUserDetailsModal;
  },

  [CHANGE_APP_USER_DETAILS_MODAL_ERRORS](state): string[] {
    return state.changeAppUserDetailsModalErrors;
  },

  [APPLICATION_USER_SEARCH_OBJECT](state): ApplicationUserSearchModel {
    return state.applicationUserSearchObject;
  },
};
